import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { SlickList, SlickItem, HandleDirective } from 'vue-slicksort';
export default {
  directives: {
    handle: HandleDirective
  },
  components: {
    SlickItem: SlickItem,
    SlickList: SlickList,
    Dropdown: function Dropdown() {
      return import('~/components/CasesDropdown.vue');
    },
    Checkbox: function Checkbox() {
      return import('~/components/form/Checkbox.vue');
    }
  },
  props: {
    layout: {
      default: 'cases'
    }
  },
  data: function data() {
    return {
      contentLang: {
        uk: "Українською",
        en: "In English"
      },
      contentLocaleOrder: ['uk', 'en'],
      content: {
        uk: false,
        en: false
      },
      userContentLocale: ['uk', 'en']
    };
  },
  computed: {
    computedUserContent: function computedUserContent() {
      var _this = this;
      var locales = [];
      this.contentLocaleOrder.forEach(function (code) {
        if (_this.content[code]) locales.push(code);
      });
      return locales;
    },
    contentCount: function contentCount() {
      return Object.values(this.content).filter(Boolean).length;
    },
    availableLocales: function availableLocales() {
      return this.$i18n.locales;
    },
    locale: function locale() {
      return this.$i18n.locale;
    },
    appStore: function appStore() {
      return useAppStore();
    }
  },
  watch: {
    locale: function locale(newVal) {
      this.$gtag('set', 'user_properties', {
        interface_locale: newVal
      });
    }
  },
  beforeMount: function beforeMount() {
    // Sync user locale with server
    if (this.$auth.user && this.$auth.user.locale != this.locale) {
      this.switchLang(this.locale);
    }
  },
  methods: {
    setup: function setup() {
      var _this2 = this;
      var defaultContentOrder = ['uk', 'en'];
      var cookieContentLocale = this.$cookieStore.contentLocale;
      if (cookieContentLocale) {
        this.userContentLocale = cookieContentLocale.split('.');
      }
      if (this.$auth.user && this.$auth.user.contentLocale) {
        this.userContentLocale = this.$auth.user.contentLocale;
      }
      this.userContentLocale = this.userContentLocale.filter(function (code) {
        return defaultContentOrder.includes(code);
      });

      // Set content locale checks
      this.userContentLocale.forEach(function (code) {
        _this2.content[code] = true;
      });

      // Set content locale order
      this.contentLocaleOrder = this.userContentLocale.slice();
      defaultContentOrder.forEach(function (code) {
        if (_this2.contentLocaleOrder.indexOf(code) < 0) {
          _this2.contentLocaleOrder.push(code);
        }
      });
    },
    switchLang: function switchLang(localeCode) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var index;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this3.$axios.$get('/user/locale', {
                params: {
                  locale: localeCode
                },
                progress: false
              });
            case 2:
              _this3.appStore.setState({
                key: 'langSwitching',
                value: true
              });

              // Set selected locale to first place in content priority
              index = _this3.contentLocaleOrder.indexOf(localeCode);
              if (index !== 0) {
                _this3.contentLocaleOrder[0] = _this3.contentLocaleOrder.splice(index, 1, _this3.contentLocaleOrder[0])[0];
              }
              _this3.content[localeCode] = true;
              _this3.setContentLang(localeCode);
              if (_this3.$helpCrunch) _this3.$helpCrunch.setLocale(localeCode);
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    setContentLang: function setContentLang(localeCode) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var feedsStore, alternate, path;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this4.$nextTick();
            case 2:
              _this4.$cookieStore.setState("contentLocale", _this4.computedUserContent.join('.'));
              _this4.$auth.user;
              if (!_this4.$auth.user) {
                _context2.next = 8;
                break;
              }
              _this4.$auth.patchUser('contentLocale', _this4.computedUserContent);
              _context2.next = 8;
              return _this4.$axios.get('/user/contentLocale', {
                params: {
                  locales: _this4.computedUserContent
                },
                progress: !localeCode
              }).catch(function (err) {
                return console.log(err);
              });
            case 8:
              // Clear all feeds
              feedsStore = useFeedsStore();
              feedsStore.clear();
              if (!localeCode) {
                // Using this hack page will reload with transition
                _this4.$router.replace({
                  path: _this4.localePath('/refresh'),
                  query: {
                    layout: _this4.layout
                  }
                });
              } else {
                // Check if page has <link rel="alternate"> for requested localeCode
                alternate = document.querySelector("link[rel=\"alternate\"][hreflang=\"".concat(localeCode, "\"]"));
                if (alternate && alternate.href) {
                  path = alternate.href.replace(/^.*\/\/[^\/]+/, '');
                  _this4.$router.push({
                    path: path
                  });
                } else {
                  _this4.$router.push({
                    path: _this4.switchLocalePath(localeCode)
                  });
                }
              }
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
  }
};